import React from 'react'
import { ApproveAndCreditProceedingsDialog, PrimaryCta } from 'components'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'features'

/**
 * Display de total amount of the assets in the selected proceedings and gives and option to approve and send them or cancel
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
function GridApproveAndCreditProceeding({ row }) {
  const user = useSelector(selectCurrentUser)
  return (
    <ApproveAndCreditProceedingsDialog
      togglerComponent={PrimaryCta}
      togglerProps={{
        size: 'grid',
        disabled: row.userapr,
      }}
      proceedingsList={[row]}
    >
      {row.userapr ? 'Lote autorizado' : 'Autorizar lote'}
    </ApproveAndCreditProceedingsDialog>
  )
}

export const MemoizedGridApproveAndCreditProceeding = React.memo(
  GridApproveAndCreditProceeding
)
